import { render, staticRenderFns } from "./NavigationBarBase.vue?vue&type=template&id=8470b280&scoped=true&"
import script from "./NavigationBarBase.vue?vue&type=script&lang=js&"
export * from "./NavigationBarBase.vue?vue&type=script&lang=js&"
import style0 from "./NavigationBarBase.vue?vue&type=style&index=0&id=8470b280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8470b280",
  null
  
)

export default component.exports